import { createInterfaceToken } from '@bmai/shared';
import type { AssistPlan, AssistRequest } from '@/shared/assist/AssistContract';

/**
 * Routes a natural-language analytics request to a structured {@link AssistPlan}.
 * The implementation calls the bmai-web BFF (`/_assist/route`), which owns the
 * workflow router/prompts and forwards shaped, bounded calls to the generic
 * telemetry LLM endpoint — no LLM SDK or model knowledge lives in the browser.
 */
export interface ISurfaceAssistEngine {
    interpret(request: AssistRequest): Promise<AssistPlan>;
}

export const ISurfaceAssistEngineToken = createInterfaceToken<ISurfaceAssistEngine>('ISurfaceAssistEngine');
